module.exports = __webpack_public_path__ + "img/logo-white.842dc24c.svg";